<script setup lang="ts">
import { rangeTrackFractions } from '@taler/domain'
import { computed } from 'vue'
import type { Target } from '../internal/types.ts'

const props = defineProps<{ target: Target }>()

// No meter without a value or without any bound: a scale with nothing to measure against would be invented.
const track = computed(() => {
  const current = props.target.evaluation.currentValue
  if (current === undefined) return undefined
  return rangeTrackFractions(
    current.value.units,
    props.target.minValue?.value.units,
    props.target.maxValue?.value.units,
  )
})
</script>

<template>
  <!-- The zone is the target's own bound or band; the tick is where the value sits on it. -->
  <div
    v-if="track"
    aria-hidden="true"
    class="relative h-2 rounded-full bg-[color:var(--color-surface-sunken)]"
  >
    <span
      class="absolute inset-y-0 border-[color:var(--color-ok)] bg-[color:color-mix(in_srgb,var(--color-ok)_18%,transparent)]"
      :class="[
        target.minValue !== undefined ? 'border-l-2' : '',
        target.maxValue !== undefined ? 'border-r-2' : '',
      ]"
      :style="{ left: `${track.zoneStart * 100}%`, right: `${(1 - track.zoneEnd) * 100}%` }"
    />
    <span
      class="absolute -top-1 h-4 w-1 -translate-x-1/2 rounded-full bg-[color:var(--color-text)] shadow-[0_0_0_2px_var(--color-surface)]"
      :style="{ left: `${track.value * 100}%` }"
    />
  </div>
</template>
